/* eslint-disable semi */

export const later = (delay, value) => {
  return new Promise((resolve) => setTimeout(resolve, delay, value));
};
